import axios from 'axios';
import { constants } from '../consts/Variables';
import keycloak from '../keycloak/keycloak';

export const API_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://127.0.0.1:8000/api/v1'
    : `${constants.API_URL}/api/v1`;

const FIWARE_URL =
  process.env.NODE_ENV === 'development'
    ? (process.env.REACT_APP_FIWARE_URL || 'https://historic-data-registry.cybernemo.synelixis.com')
    : constants.FIWARE_URL;

const SENSING_SERVICES_URL =
  process.env.NODE_ENV === 'development'
    ? (process.env.REACT_APP_SENSING_SERVICES_URL || 'https://historic-data-registry.cybernemo.synelixis.com')
    : constants.SENSING_SERVICES_URL;

export const DRONE_ENTITY =
  process.env.NODE_ENV === 'development'
    ? (process.env.REACT_APP_FIWARE_DRONE_ENTITY || 'nemo-smart-farming-drone')
    : constants.FIWARE_DRONE_ENTITY;

const api = axios.create({ baseURL: API_URL });
const fiwareApi = axios.create({ baseURL: FIWARE_URL });
const sensingServicesApi = axios.create({ baseURL: SENSING_SERVICES_URL });

const addResponseInterceptor = (client) => {
  client.interceptors.response.use(
    res => res,
    async error => {
      const original = error.config;
      if (error.response?.status === 401 && !original._retry) {
        original._retry = true;
        try {
          await keycloak.updateToken(30);
          localStorage.setItem('token', keycloak.token);
          original.headers['Authorization'] = `Bearer ${keycloak.token}`;
          return client(original);
        } catch {
          localStorage.removeItem('token');
          keycloak.logout();
        }
      }
      return Promise.reject(error);
    }
  );
};

addResponseInterceptor(api);
addResponseInterceptor(fiwareApi);
addResponseInterceptor(sensingServicesApi);

const buildHeaders = (deviceType = 'synfield') => {
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Fiware-service': deviceType,
    'Fiware-servicepath': '/',
  };
  const token = localStorage.getItem('token');
  if (token) headers.Authorization = `Bearer ${token}`;
  return { headers };
};

export const POST = async (url, values, deviceType = 'synfield') => {
  const { data } = await api.post(url, values, buildHeaders(deviceType));
  return data;
};

export const GET = async (url, useFiware = false, useSensingServices = false, deviceType = 'synfield') => {
  const client = useFiware ? fiwareApi : (useSensingServices ? sensingServicesApi : api);
  const { data } = await client.get(url, buildHeaders(deviceType));
  return data;
};

export const PUT = async (url, values) => {
  const { data } = await api.put(url, values, buildHeaders());
  return data;
};

export const PATCH = async (url, values) => {
  const { data } = await api.patch(url, values, buildHeaders());
  return data;
};

export const DELETE = async (url) => {
  const { data } = await api.delete(url, buildHeaders());
  return data;
};
